import { takeEvery, put, call, all } from "redux-saga/effects";
import apiCall from "../services";

const apiUrl = process.env.REACT_APP_API_URL;
const enviromentUrl = process.env.REACT_APP_ENVIROMENT;

function* getPermissionsList(actions) {
  let uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
    };

    let url =
      actions.query === null
        ? apiUrl + "/opa-permissions?page=" + actions.page
        : apiUrl + "/opa-permissions" + actions.query;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "get", url, requestOptions);

    yield put({ type: "LIST_PERMISSION_RESPONSE_GET", value: response });
  } catch (error) {
    yield put({ type: "LIST_PERMISSION_RESPONSE_GET", value: error });
  }
}

function* getPermission(actions) {
  let uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
    };

    let url =
      actions.query === null
        ? apiUrl + "/opa-permission/"
        : apiUrl + "/opa-permission/" + actions.query;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "get", url, requestOptions);

    yield put({ type: "PERMISSION_RESPONSE_GET", value: response });
  } catch (error) {
    yield put({ type: "PERMISSION_RESPONSE_GET", value: error });
  }
}

function* resetPermission() {
  yield put({ type: "PERMISSION_RESPONSE_RESET" });
}

function* createPermission(actions) {
  let uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.form),
    };

    let url = apiUrl + "/opa-permission";

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "POST", url, requestOptions);

    let responseStatus = "warning";

    if (response) {
      if (response.status == 200) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({ type: "PERMISSION_RESPONSE_ADD", value: { ...response, responseStatus } });
    return response;
  } catch (error) {
    yield put({ type: "PERMISSION_RESPONSE_ADD", value: { ...error, responseStatus: "error" } });
    throw error;
  }
}

function* editPermission(actions) {
  let uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers,
      body: JSON.stringify(actions.form),
    };

    let url = apiUrl + "/opa-permission/" + actions.id;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "PATCH", url, requestOptions);

    let responseStatus = "warning";

    if (response) {
      if (response.status == 200) {
        responseStatus = "success";
      } else {
        responseStatus = "error";
      }
    }

    yield put({ type: "PERMISSION_RESPONSE_EDIT", value: { ...response, responseStatus } });
    return response;
  } catch (error) {
    yield put({ type: "PERMISSION_RESPONSE_EDIT", value: { ...error, responseStatus: "error" } });
    throw error;
  }
}

function* deletePermission(actions) {
  let uuid = getSetCookie();
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid,
    };

    const requestOptions = {
      headers: headers
    };

    let url = apiUrl + "/opa-permission/" + actions.id;

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "DELETE", url, requestOptions);

    if (response.status === 204 || response.status === 200) {
      yield put({
        type: "PERMISSION_RESPONSE_DELETE",
        payload: { status: response.status, responseStatus: "success" },
      });
    } else {
      yield put({
        type: "PERMISSION_RESPONSE_DELETE",
        payload: response,
      });
    }
  } catch (error) {
    yield put({
      type: "PERMISSION_RESPONSE_DELETE",
      value: {
        error: error.message || "Unknown error",
        responseStatus: "error",
      },
    });
  }
}

export function* getSagaPermissionsList() {
  yield takeEvery("GET_LIST_PERMISSIONS", getPermissionsList);
}

export function* getSagaPermission() {
  yield takeEvery("GET_PERMISSION", getPermission);
}

export function* resetSagaPermission() {
  yield takeEvery("RESET_PERMISSION", resetPermission);
}

export function* createSagaPermission() {
  yield takeEvery("ADD_PERMISSION", createPermission);
}

export function* editSagaPermission() {
  yield takeEvery("EDIT_PERMISSION", editPermission);
}

export function* deleteSagaPermission() {
  yield takeEvery("DELETE_PERMISSION", deletePermission);
}

const getSetCookie = () => {
  return window.localStorage.getItem("uuidSetCookie");
};
